<template>
  <div>
    <headers /> <menus />
    <router-view />
  </div>
</template>

<script>
import headers from "../components/Headers.vue";
import menus from "../components/Menus.vue";
export default {
    components: { headers, menus },
    data() {
        return {
            sidebarOpen: true,
            authenticated: false
        };
    }
};
</script>

<style lang="scss" scoped>

</style>

<style>

</style>
